{
 "name": "2_menu_single_bugg",
 "bin": "2_menu_single_bugg.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "menu_stuff", "parent": 1, "t": [0,0,0], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [7,7,7]}
 ],
 "parts": [
  {"node": 10, "vertexCount": 6, "posOffset": 0, "nrmOffset": 72, "uvOffset": 144, "material": "menu", "color": [0.588,0.588,0.588,1], "texture": "2_menu_single_bugg.png"}
 ],
 "anims": [
  {"name": "move", "duration": 0.46667, "fps": 30, "frames": 15, "offset": 192}
 ]
}
